var chart_table_content;

export default chart_table_content = Vue.extend({
  props: {
    title: {
      type: String,
      default: ''
    },
    fieldType: {
      type: String,
      default: ''
    }
  },

  template: `
    <div class="chart-wrapper mb-6">
      <div class="chart-field-header justify-between mb-2">
        <div class="chart-field-title">{{ title }}</div>
        <div class="chart-header-message-content justify-box">
          <slot name="chart-data-counts"></slot>
          <div class="text-small ml-6 gray-text">{{ Skylark.Helpers.t("field.type." + fieldType) }}</div>
        </div>
      </div>
      <div class="chart-group">
        <slot name="chart-content"></slot>
        <div class="chart-datatable">
          <div class="fixed-table-header">
            <table class="normal-table noborder">
              <thead>
                <tr>
                  <th width="220px"><span class="content text-ellipsis">选项</span></th>
                  <th width="80px">
                    <label>
                      <span class="content text-ellipsis">数量</span>
                      <i class="slp-half-arrow-v-square white-text sort-icon" @click="toggleChangeSort"></i>
                    </label>
                  </th>
                  <th width="80px"><span class="content text-ellipsis">占比</span></th>
                </tr>
              </thead>

              <tbody>
                <slot name="chart-data-table-tbody"></slot>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  `,

  methods: {
    toggleChangeSort: function() {
      return this.$emit('toggleChangeSort');
    }
  }
});
